/* Account page (KwikPass): My Orders in the order the orders were PLACED (13 Oct 2026, Guneet).
 *
 * KwikPass lists orders newest-created-in-Shopify first. Older Magento orders were rebuilt in
 * Shopify on 28 Sep, after newer ones were imported, so a shopper's latest order could sit dozens
 * of rows down (order 1009852869 was 35th of 65) and look missing.
 *
 * KwikPass reads the list from GoKwik (GET gkx.gokwik.co/kp/api/v1/customer/orders, paging in the
 * `first` / `after` request headers) and every order in the answer carries `processedAt`, the date
 * it was placed. So when KwikPass asks for a page, this asks GoKwik for the WHOLE list with the
 * same headers (250 a call), sorts it by `processedAt`, newest first, and answers KwikPass's own
 * request from that, a page at a time, with cursors of its own (`nb:<offset>`).
 *
 * Anything unexpected - a failed call, an answer in another shape, no dates - and KwikPass's
 * request goes out untouched, which is exactly the list as it was before this file.
 * Undo = remove the <script> line for this file in snippets/newbrand-kwikpass.liquid.
 */
(function () {
  'use strict';
  var X = window.XMLHttpRequest;
  if (!X || X.prototype.__nbOrders) return;
  var P = X.prototype;
  P.__nbOrders = true;

  var LIST = /\/kp\/api\/v1\/customer\/orders(\?|$)/;
  var PAGE = 250, MAX_CALLS = 8, WAIT_MS = 15000, CURSOR = 'nb:';
  var open = P.open, setHeader = P.setRequestHeader, send = P.send;
  var held = null;                         // { key, list, base } - the last sorted list

  function header(h, name) {
    for (var k in h) if (k.toLowerCase() === name) return h[k];
    return '';
  }
  function placed(edge) {
    var t = Date.parse(edge && edge.node && edge.node.processedAt);
    return isNaN(t) ? null : t;
  }

  // One page of the real list, asked exactly as KwikPass asks.
  function ask(req, after, done) {
    var x = new X(), over = false;
    function end(json) { if (!over) { over = true; clearTimeout(timer); done(json); } }
    var timer = setTimeout(function () { try { x.abort(); } catch (e) {} end(null); }, WAIT_MS);
    x.__nbOwn = true;
    open.call(x, 'GET', req.url, true);
    for (var k in req.h) {
      var low = k.toLowerCase();
      if (low !== 'first' && low !== 'after') setHeader.call(x, k, req.h[k]);
    }
    setHeader.call(x, 'first', String(PAGE));
    if (after) setHeader.call(x, 'after', after);
    x.onload = function () {
      var j = null;
      try { j = JSON.parse(x.responseText); } catch (e) {}
      end(x.status === 200 ? j : null);
    };
    x.onerror = x.onabort = function () { end(null); };
    send.call(x);
  }

  // The whole list, sorted. done(null) = leave KwikPass's own request alone.
  function all(req, done) {
    var edges = [], base = null, calls = 0;
    (function next(after) {
      ask(req, after, function (j) {
        var o = j && (j.isSuccess || j.success) && j.data && j.data.orders;
        if (!o || !Array.isArray(o.edges) || !o.pageInfo) return done(null);
        base = base || j;
        edges = edges.concat(o.edges);
        calls++;
        if (o.pageInfo.hasNextPage) {
          if (calls >= MAX_CALLS || !o.pageInfo.endCursor) return done(null);
          return next(o.pageInfo.endCursor);
        }
        var dated = edges.filter(function (e) { return placed(e) !== null; }).length;
        if (edges.length && !dated) return done(null);
        // Newest placed first; equal or missing dates keep GoKwik's own order.
        var list = edges.map(function (e, i) { return { e: e, i: i, t: placed(e) }; });
        list.sort(function (a, b) {
          if (a.t === b.t) return a.i - b.i;
          if (a.t === null) return 1;
          if (b.t === null) return -1;
          return b.t - a.t;
        });
        done({ list: list.map(function (r) { return r.e; }), base: base });
      });
    })(null);
  }

  function page(got, from, size) {
    var to = Math.min(got.list.length, from + size);
    var out = {};
    for (var k in got.base) out[k] = got.base[k];
    out.data = {};
    for (var d in got.base.data) out.data[d] = got.base.data[d];
    out.data.orders = {
      pageInfo: { hasNextPage: to < got.list.length, endCursor: to < got.list.length ? CURSOR + to : null },
      edges: got.list.slice(from, to).map(function (e, i) {
        var c = {};
        for (var k2 in e) c[k2] = e[k2];
        c.cursor = CURSOR + (from + i + 1);
        return c;
      })
    };
    out.timestamp = Date.now();
    return JSON.stringify(out);
  }

  // Answer KwikPass's request object as if GoKwik had.
  function answer(xhr, url, status, text) {
    if (xhr.__nbGone) return;
    var type = '';
    try { type = xhr.responseType; } catch (e) {}
    var body = text;
    if (type === 'json') { try { body = JSON.parse(text); } catch (e) { body = null; } }
    function fix(k, v) { try { Object.defineProperty(xhr, k, { configurable: true, get: function () { return v; } }); } catch (e) {} }
    fix('readyState', 4); fix('status', status); fix('statusText', status === 200 ? 'OK' : '');
    fix('responseURL', url); fix('response', body);
    if (type === '' || type === 'text') fix('responseText', text);
    xhr.getAllResponseHeaders = function () { return 'content-type: application/json; charset=utf-8\r\n'; };
    xhr.getResponseHeader = function (k) { return /^content-type$/i.test(k) ? 'application/json; charset=utf-8' : null; };
    ['readystatechange', 'load', 'loadend'].forEach(function (t) {
      try { xhr.dispatchEvent(new Event(t)); } catch (e) {}
    });
  }

  P.open = function (method, url) {
    this.__nbReq = (!this.__nbOwn && String(method).toUpperCase() === 'GET' && LIST.test(String(url || '')))
      ? { url: String(url), h: {} } : null;
    return open.apply(this, arguments);
  };
  P.setRequestHeader = function (k, v) {
    if (this.__nbReq) this.__nbReq.h[k] = v;
    return setHeader.apply(this, arguments);
  };
  P.send = function () {
    var req = this.__nbReq, xhr = this, args = arguments;
    if (!req) return send.apply(this, args);
    var size = parseInt(header(req.h, 'first'), 10);
    if (!(size > 0)) size = 5;
    var after = String(header(req.h, 'after') || '');
    var ours = after.indexOf(CURSOR) === 0;
    // A cursor GoKwik issued: that list was not ours, so neither is its next page.
    if (after && !ours) return send.apply(this, args);
    var from = ours ? parseInt(after.slice(CURSOR.length), 10) || 0 : 0;
    var key = header(req.h, 'x-shopify-customer-access-token') + '|' + header(req.h, 'gk-access-token');
    var abort = xhr.abort;
    xhr.abort = function () { xhr.__nbGone = true; return abort.apply(xhr, arguments); };

    if (ours && held && held.key === key) return void setTimeout(function () { answer(xhr, req.url, 200, page(held, from, size)); }, 0);
    all(req, function (got) {
      if (xhr.__nbGone) return;
      if (!got) {
        held = null;
        // First page: the real request, untouched. A later page of ours has no real twin.
        if (!ours) { try { return send.apply(xhr, args); } catch (e) { return; } }
        return answer(xhr, req.url, 502, '{"success":false,"isSuccess":false,"error":"Please try again."}');
      }
      held = { key: key, list: got.list, base: got.base };
      answer(xhr, req.url, 200, page(held, from, size));
    });
  };
})();
